import { SidebarUserMenu } from "~/components/sidebar/SidebarUserMenu";
import { useAuth } from "~/contexts/AuthProvider";
import { getUserFullName } from "~/helpers/user";
import { Logo } from "~/utils/white-label";

import styles from "./SelectTeamLayout.module.scss";

const SelectTeamLayout = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();

  const currentUserName = getUserFullName(user);

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.logo}>
          <Logo />
        </div>

        <div className={styles.spacer} />

        <SidebarUserMenu
          isSidebarOpen={false}
          label={currentUserName}
          popoverPlacement="right"
          withSettings={false}
        />
      </aside>

      <main className={styles.content}>{children}</main>
    </div>
  );
};

export default SelectTeamLayout;
